import { IgrSeries } from './igr-series';
import { TypeRegistrar } from "igniteui-react-core";
/**
 * Event arguments for the Financial Chart's custom indicator event.
*/
var IgrFinancialChartCustomIndicatorArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrFinancialChartCustomIndicatorArgs() {
    }
    Object.defineProperty(IgrFinancialChartCustomIndicatorArgs.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrFinancialChartCustomIndicatorArgs.prototype.onImplementationCreated = function () {
    };
    IgrFinancialChartCustomIndicatorArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrFinancialChartCustomIndicatorArgs.prototype, "indicatorInfo", {
        get: function () {
            if (!this.i.indicatorInfo) {
                return null;
            }
            if (!this.i.indicatorInfo.externalObject && TypeRegistrar.isRegistered("igr-financial-event-args")) {
                var e = TypeRegistrar.create("igr-financial-event-args");
                e._implementation = this.i.indicatorInfo;
                this.i.indicatorInfo.externalObject = e;
            }
            if (this.i.indicatorInfo.externalObject) {
                return this.i.indicatorInfo.externalObject;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFinancialChartCustomIndicatorArgs.prototype, "series", {
        /**
     * The Series in context.
    */
        get: function () {
            var r = this.i.series;
            if (r == null) {
                return null;
            }
            if (!r.externalObject) {
                var e = IgrSeries._createFromInternal(r);
                if (e) {
                    e._implementation = r;
                }
                r.externalObject = e;
            }
            return r.externalObject;
        },
        set: function (v) {
            v == null ? this.i.series = null : this.i.series = v.i;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrFinancialChartCustomIndicatorArgs.prototype, "index", {
        /**
         * An integer representing the position of the associated custom indicator in its host.
        */
        get: function () {
            return this.i.index;
        },
        set: function (v) {
            this.i.index = +v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrFinancialChartCustomIndicatorArgs;
}());
export { IgrFinancialChartCustomIndicatorArgs };
